<script>
  import { createEventDispatcher } from 'svelte';
	import VisualTimer from './components/VisualTimer.svelte';
	import ConfigForm from './components/ConfigForm.svelte';
	import Time from './components/Time.svelte';
  import PlayButton from './components/PlayButton.svelte';
  import Messages from './components/Messages.svelte';
  import Version from './components/Version.svelte';
  import Row from './layout/Row.svelte';
  import Bottom from './layout/Bottom.svelte';
  import Flexer from './layout/Flexer.svelte';
  import Section from './layout/Section.svelte';
	import { rounds, timeOn, timeOff, totalTime } from './configStore'; 
  import { generateSteps } from './timer';

  const dispatch = createEventDispatcher();

  let steps = [];
  let isOpen = false;
	$: if($rounds > 0) {
		steps = generateSteps($rounds, $timeOn, $timeOff);
	}

  function handleStart() {
    dispatch('start');
  }
  function toggleInfoOpen() {
    isOpen = !isOpen;
  }
</script>

<Version on:click={toggleInfoOpen} />
<Flexer>
  <Row centered={true}>
    <Time total={$totalTime} color="white" />
  </Row>
  <Row centered={true}>
    <PlayButton on:click={() => handleStart()} />
  </Row>
</Flexer>
<Bottom>
  <Section>
    <VisualTimer timeOn={$timeOn} timeOff={$timeOff} steps={steps} />
  </Section>
  <ConfigForm />
</Bottom>
<Messages on:click={toggleInfoOpen} isOpen={isOpen} />
